import { toggleUnreadIndicator } from '@widgets/Comments/lib/polling/toggleUnreadIndicator';

import { forEachPositionTriggerByGuid } from './forEachPositionTriggerByGuid';

export const removeUnreadIndicatorForPositionGuid = (positionGuid: string): void => {
    forEachPositionTriggerByGuid(positionGuid, (element) => {
        toggleUnreadIndicator({
            triggerElement: element,
            shouldShow: false,
            enableRemoveIndicator: true,
        });
    });
};
